import CloseButton from './CloseButton.js';

import HeartSimpleShape from '@/components/common/svg/shapes/HeartSimpleShape.tsx';
import {
  notificationContainerStyles,
  notificationIconContainerStyle,
  notificationImgContainerStyles,
  notificationImgStyles,
  notificationsHeadlineStyle,
  notificationSubtextStyle,
  notificationTextContainerStyle
} from '@/components/Toast/components/styles';
import { INotification } from '@/components/Toast/components/types/notification.interface.ts';
import { Image } from '@/components/common/Image/Image.tsx';

const MatchNotification = ({ onClose, contact, msg }: INotification) => {
  return (
    <div style={notificationContainerStyles}>
      <div style={notificationImgContainerStyles}>
        <Image
          style={notificationImgStyles}
          src={contact?.photo_url}
          alt="Like Notification"
        />
        <HeartSimpleShape
          width={16}
          height={16}
          fillColor="#ffffff"
          style={{
            position: 'absolute',
            bottom: '-4px',
            right: '-4px',
            background: '#F85A89',
            borderRadius: '50%',
            padding: '4px'
          }}
        />
      </div>
      <div style={notificationTextContainerStyle}>
        <div style={notificationsHeadlineStyle}>{contact?.name}</div>
        <p style={notificationSubtextStyle}>{msg}</p>
      </div>
      <div style={notificationIconContainerStyle}>
        <CloseButton handleClose={onClose} />
      </div>
    </div>
  );
};

export default MatchNotification;
